import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { apiClient } from '../helpers/Axios'
import AnimatePage from '../components/AnimatePage'
import Wrapper from '../helpers/Wrapper'
import { Helmet } from 'react-helmet'
import SectionHead from '../components/SectionHead'
import DatabaseContent from '../components/DatabaseContent'

function Terms() {
    const { data, status } = useQuery({
        queryKey: ['privacy-policy'],
        queryFn: async () => {
            const res = await apiClient('/shop/term-and-condition')
            return res.data
        }
    })

    return (
        <div className="mx-auto w-full max-w-7xl">
            <AnimatePage>
                <Helmet>
                    <title>Term & Condition</title>
                </Helmet>
                <Wrapper>
                    <div className='w-full relative mt-16'>
                        <SectionHead title={"Term & Condition"} description={"Term & Condition"} />

                        {/* Contents */}
                        {status === 'success' && (
                            <div className="mt-10" >
                                <DatabaseContent htmlContent={data?.content} />
                            </div>
                        )}
                    </div>
                </Wrapper>
            </AnimatePage>
        </div>
    )
}

export default Terms